// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_cmp_settings = require("./MM_cmp_settings.res.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");

function useHighlightColor() {
  return Local_storage_utils.useStateFromLocalStorage("pe-index-highlight-color", (function (strOpt) {
                if (strOpt !== undefined) {
                  return Core__Option.getOr(MM_cmp_settings.allColors.find(function (c) {
                                  return c === strOpt;
                                }), MM_cmp_settings.defaultHighlightColor);
                } else {
                  return MM_cmp_settings.defaultHighlightColor;
                }
              }), (function (str) {
                return str;
              }));
}

exports.useHighlightColor = useHighlightColor;
/* MM_cmp_settings Not a pure module */
